import * as React from 'react';
import { ProtectedPageWrapper } from '../../../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { SingleColumnLayout } from '../../../../designSystem/layouts/SingleColumnLayout';
import { H2 } from '../../../../designSystem/typography/Heading';
import { buildTranslator, CustomForm, CustomFormReportData, isInputField } from '../../../../amorg-common';
import { deleteCustomFormReport, getCustomForm, getCustomFormReport } from '../../../../api/customFormClientApi';
import { Redirect, useParams } from 'react-router-dom';
import { LoadingPageOverlay } from '../../../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../../../designSystem/PageHeader';
import { customFormHelper, CustomFormFilter } from '../../../../utils/customFormHelper';
import { CustomFormFiltersPanel } from './_components/CustomFormFiltersPanel';
import clone from 'clone';
import { CustomFormTabHeader } from '../_components/CustomFormTabHeader';
import { ToolBarContainer, ToolBarButton } from '../../../../designSystem/compositeComponents/ButtonToolBar';
import { customFormFieldFactory } from '../../_components/customFormFieldFactory';
import { useReactToPrint } from 'react-to-print';
import { PrintCustomFormReportPage } from './PrintCustomFormReportPage';



export function CustomFormReportPage():JSX.Element
{
    const [redirect, setRedirect] = React.useState(false);

    const {formId} = useParams<{formId:string}>();

    const [state, setState] = React.useState<{
        isLoading:boolean, 
        form:CustomForm, 
        report:CustomFormReportData, 
        filters:CustomFormFilter[]
    }>({ isLoading:true, form:null, report:null, filters:null });

    React.useEffect(()=>{
        const getData = async () => {
            const report = await getCustomFormReport(formId);
       
            const form = await getCustomForm(formId);
            setState({ 
                isLoading:false, 
                form, 
                report, 
                filters:customFormHelper.buildFilters(form, report) });
        }
        getData();
    }, []);

    function handleFilterChange(fieldId:string, value:string)
    {
        const newFilters = clone(state.filters);
        newFilters.find(f => f.fieldId === fieldId).selectedValue = value;
        setState({ ...state, filters:newFilters });
    }

    const filteredData:CustomFormReportData = { ...state.report, segmentReports:[] };
    if(state.report){
        filteredData.segmentReports = customFormHelper.applyReportFilters(
            state.report.segmentReports, 
            state.filters
        );
    }

    const translator = buildTranslator('da');
    const formName = state.form?.name ? translator(state.form?.name) : '';

    const printRef = React.useRef(null);
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: formName,
    
    });

    return (
        
        <ProtectedPageWrapper requiredPermissions={['ViewCustomFormAnswerList']} selectedMenuItemKey={state.form?.category || ''}>
            <SingleColumnLayout  
                noDivider
                contentContainer={
                    <>
                        {redirect &&
                            <Redirect to={`/customForms/${state.form.activityId}`} />
                        }

                        <LoadingPageOverlay loading={state.isLoading} />

                        <CustomFormTabHeader selectedTab='overview'
                            onClick={(tabName) => {
                                if(tabName === 'answers')
                                    setRedirect(true);
                            }}
                        />
                        <PageHeader
                            headerText={'Overblik'}
                            headerStyle="secondary-gray"
                            buttons={
                                <ToolBarContainer>
                                    <ToolBarButton
                                        icon='interface_actions_synchronize'
                                        tooltip= 'Gendan rapport'
                                        variant= 'text'
                                        onClick={async() => {
                                            setState({ isLoading:true, form:state.form, report:null, filters:null });
                                            await deleteCustomFormReport(formId);
                                            const report = await getCustomFormReport(formId);
                                            setState({ 
                                                isLoading:false, 
                                                form:state.form, 
                                                report, 
                                                filters:customFormHelper.buildFilters(state.form, report) 
                                            });
                                        }}
                                    />
                                    <ToolBarButton
                                        icon='interface_actions_print'
                                        tooltip='Print'
                                        variant='text'
                                        onClick={printFn}
                                        />
                                </ToolBarContainer>
                        } />

                        
                        <PrintCustomFormReportPage
                            form={state.form}
                            report={state.report}
                            filters={state.filters}
                            innerRef={printRef} />        
                    
                        
                        
                        <H2>{formName}</H2>
                        {state.form && state.report && 
                            <>
                            <CustomFormFiltersPanel
                                form={state.form}
                                report={state.report}
                                filter={state.filters}
                                onFilterChange={handleFilterChange}
                            />
                                                           
                            
                            {state.form.fields.filter(f => isInputField(f)).map((field) => 
                                customFormFieldFactory.getReportFieldValueComponent(field, filteredData.segmentReports)
                            )}
                            </>
                        }
                    </>
                } />
            
        </ProtectedPageWrapper>
    );
}




